/**
 * @file helper.class.js
 * @description Defines static functions that are used throughout classes.
 */

class Helper {

  /**
   * @description Returns the elements height including padding, margin, and border;
   * @param {node} element 
   */
  static getHeight(element) {
    let style = element.currentStyle || window.getComputedStyle(element);
    let height = element.clientHeight;
    let margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    let padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    let border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    return height + margin + padding + border;
  }

  /**
   * @description Gets the transition duration
   * @param {Node} element 
   * @param {boolean} inMilliseconds If true returns the transition duration in milliseconds.
   * @returns 
   */
  static getTransitionDuration(element, inMilliseconds) {
    let computedStyle = window.getComputedStyle(element);
    let transitionDuration = computedStyle.transitionDuration.replace(/[^0-9.]/g, '');
    if (inMilliseconds) return transitionDuration * 1000;
    return transitionDuration;
  }

  /**
   * @description Set the transition duration
   * @param {*} $element 
   */
  static setTransitionDuration(element, duration) {
    element.style.transitionDuration = duration;
  }

  /**
   * @description Toggles the specified class on the passed element.
   * @param {Node} element 
   * @param {string} className 
   */
  static toggleClass(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  /**
   * @description Selects the node based on the passed selector. Returns false if the element is not found.
   * @param {string} selector 
   * @returns Node
   */
  static getElement(selector) {
    return document.querySelector(selector) !== null ? document.querySelector(selector) : false;
  }

    /**
   * @description Selects the nodes based on the passed selector. Returns false if the element is not found.
   * @param {string} selector 
   * @returns Node list
   */
  static getElements(selector) {
    return document.querySelectorAll(selector) !== null ? document.querySelectorAll(selector) : false;
  }
}